import { Config } from '@/config';
import apiService from '@/services/api.service';
import type { DTOPage } from '@/store/page.interface';

// A preview reads the page as its draft, for an administrator of the community only (`preview=draft`).
const previewParams = (preview: boolean) => (preview ? { preview: 'draft' } : undefined);

class PagesService {
  getPage(pageId: number, { preview = false } = {}): Promise<DTOPage | null> {
    return this.read(`${pageId}`, preview);
  }

  getPageBySlug(slug: string, { preview = false } = {}): Promise<DTOPage | null> {
    return this.read(`slug:${slug}`, preview);
  }

  // The page at `/pages/<path>`, or null when it cannot be read: the caller shows a page that is not found.
  private async read(path: string, preview: boolean): Promise<DTOPage | null> {
    try {
      const response = await apiService.get<DTOPage>(
        `${Config.api.backend.urlV2}/pages/${path}`,
        previewParams(preview),
      );
      return response.data ?? null;
    } catch (error) {
      console.error(`Failed to load page ${path}:`, error);
      return null;
    }
  }
}

export const pagesService = new PagesService();
